import axios from 'axios'
const axiosHttp = axios.create();
  

axiosHttp.interceptors.request.use(
    (config) => {
      return {
        ...config,
      };
    },
    (error) => {
      return Promise.reject(error);
    }
  );
  
axiosHttp.interceptors.response.use(
    (response) => {
      //const url = response.config.url;
  
      //setLocalStorageToken(token);
      return response;
    },
    (error) => {
      if (error.response.status === 401) {
        //(`unauthorized :)`);
        // window.location.href = '/';
      }
      return Promise.reject(error);
    }
  );
  
  export default axiosHttp;